<template>
  <div class="layout" v-if="article" :class="{mobile: isMobile}" >
    <h2>{{article.title}}</h2>
    <span v-if="article.date">{{new Date(Number(article.date)).format('yyyy-MM-dd')}} 发表</span>
    <span>{{article.label}}</span>
    <div v-html="article.content" class="new-content"></div>
  </div>
</template>

<script>
// import browser from '@/util/browser'
const browser = {mobile: false}

export default {
  props: {
    params: {
      default: () => {}
    }
  },
  data () {
    return {
      isMobile: browser.mobile,
      article: null
    }
  },
  async mounted () {
    let result = (await this.$http.get('/news/' + this.params.id)).data.content
    this.article = result
  }
}
</script>

<style scoped>
.layout {
  margin: 50px auto;
  max-width: 780px;
  padding: 0 20px;
  text-align: center;
}

.layout.mobile {
  text-align: left;
}

.layout > h2 {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
}

.layout > span {
  color: #989898;
  font-size: 14px;
  margin: 15px 0;
  display: block;
}

.layout > img {
  display: block;
  max-width: 100%;
}

.layout > div {
  font-size: 14px;
  line-height: 25px;
  color: #989898;
  margin-top: 25px;
}

.new-content {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/page/information/news/details.vue